
interface Props {
  matchSummary: string | undefined;
  /** Active criteria labels to show as pills */
  activeCriteria: string[];
  onClear: () => void;
}

export function MatchSummaryBanner({ matchSummary, activeCriteria, onClear }: Props) {
  return (
    <div
      style={{
        padding: '6px 8px',
        borderBottom: '1px solid #bfdbfe',
        background: '#eff6ff',
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      {/* ── Top row: icon + summary + clear button ── */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
        <AdjustmentsIcon />
        <span
          style={{
            flex: 1,
            fontSize: 11,
            color: '#1e40af',
            fontWeight: 600,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            minWidth: 0,
          }}
        >
          {matchSummary ?? 'Matching active'}
        </span>
        <button
          onClick={onClear}
          title="Clear matching filters"
          style={{
            background: 'none',
            border: '1px solid #93c5fd',
            borderRadius: 10,
            cursor: 'pointer',
            padding: '1px 7px',
            fontSize: 10,
            color: '#1d4ed8',
            lineHeight: 1.4,
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 3,
            transition: 'background 0.1s',
          }}
          onMouseEnter={(e) => { (e.currentTarget as HTMLButtonElement).style.background = '#dbeafe'; }}
          onMouseLeave={(e) => { (e.currentTarget as HTMLButtonElement).style.background = 'none'; }}
        >
          Clear ✕
        </button>
      </div>

      {/* ── Active criteria pills ── */}
      {activeCriteria.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 3, paddingLeft: 1 }}>
          {activeCriteria.map((c) => (
            <span
              key={c}
              style={{
                fontSize: 9,
                padding: '1px 6px',
                borderRadius: 8,
                background: '#dbeafe',
                color: '#1d4ed8',
                border: '1px solid #93c5fd',
                whiteSpace: 'nowrap',
              }}
            >
              {c}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}

function AdjustmentsIcon() {
  return (
    <svg
      width="12" height="12" viewBox="0 0 24 24"
      fill="none" stroke="#1d4ed8" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round"
      aria-hidden="true" style={{ flexShrink: 0 }}
    >
      <line x1="4" y1="6" x2="20" y2="6" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <line x1="4" y1="18" x2="20" y2="18" />
      <circle cx="8" cy="6" r="2" fill="#1d4ed8" stroke="none" />
      <circle cx="16" cy="12" r="2" fill="#1d4ed8" stroke="none" />
      <circle cx="10" cy="18" r="2" fill="#1d4ed8" stroke="none" />
    </svg>
  );
}
